import { validateDetailContent } from '../protocol/detail-views.js';

const TYPES = Object.freeze({ result_devices: 'device_cards', action_devices: 'device_cards', result_scenes: 'scene_cards', action_scenes: 'scene_cards' });
export function remoteManualList(card) {
  return !!(card.source && TYPES[card.source.kind] === card.type);
}
// A detail container supplies a descriptor only. The SAME list owner reads the
// first page, retries and later pages; there is no container-level prefetch.
export function manualDetailCard(source, title) {
  if (!source || !['action_devices', 'action_scenes'].includes(source.kind)) throw Error('INVALID_DETAIL_SOURCE');
  return { type: TYPES[source.kind], version: 1, title, source, items: [], hasMore: false };
}
export function readManualPage(client, source, cursor) {
  const { sessionId, turnId, revision, componentId, actionId } = source;
  if (['result_devices', 'result_scenes'].includes(source.kind))
    return client.post('result/page', { sessionId, turnId, revision, componentId, cursor });
  if (['action_devices', 'action_scenes'].includes(source.kind))
    return client.post(source.kind === 'action_devices' ? 'action/devices' : 'action/scenes', { sessionId, turnId, actionId, cursor });
  throw Error('INVALID_DETAIL_SOURCE');
}
export function manualItemKey(item, type) {
  return type === 'scene_cards' ? item.ref.sceneId : JSON.stringify([item.ref.regionId, item.ref.productId, item.ref.deviceId || null]);
}
export function acceptManualPage(card, page, cursor, previous = []) {
  const source = card.source;
  const action = ['action_devices', 'action_scenes'].includes(source.kind);
  if (page.sessionId !== source.sessionId || page.turnId !== source.turnId ||
      (action ? page.actionId !== source.actionId : page.revision !== source.revision || page.componentId !== source.componentId) ||
      (page.type && page.type !== card.type) || typeof page.hasMore !== 'boolean' ||
      (page.hasMore && (typeof page.nextCursor !== 'string' || !page.nextCursor || page.nextCursor === cursor)) ||
      !Array.isArray(page.items) || page.items.length > 20) throw Error('WRONG_RESPONSE');
  validateDetailContent({ ...card, ...page, source }, true);
  const unique = new Map(previous.map(item => [manualItemKey(item, card.type), item]));
  page.items.forEach(item => unique.set(manualItemKey(item, card.type), item));
  return { ...page, source, items: Array.from(unique.values()) };
}
